import { BaseItem, FindAll } from './common';
import { PatientCalendarEntry } from './calendarSync';

import * as Content from './notification/content';

import { ImportError } from './provider';
import { FindAllViewOptionsBase } from './encounter';

interface MessageLocalizationMap {
  email: Content.LocalizationMap;
  sms: Content.LocalizationMap;
  voice?: Content.LocalizationMap;
}

interface MessageContentsConfig extends Partial<MessageLocalizationMap> {
  contentIds?: string[];
}

export interface EncounterBroadcastArgs extends MessageContentsConfig {
  encounterIds: string[];
}

export interface EncounterBatchBroadcastArgs {
  encounterFilter: FindAllViewOptionsBase;
  dry?: boolean;
}

export interface BatchBroadcastResult {
  success: boolean;
  total: number;
  totalPatients?: number;
  broadcast?: Broadcast;
}

interface ImportRow {
  firstName: PatientCalendarEntry['firstName'];
  lastName: PatientCalendarEntry['lastName'];
  dateOfBirth: PatientCalendarEntry['dateOfBirth'];
  patientEhrId: PatientCalendarEntry['patientEhrId'];
  cellPhoneNumber?: PatientCalendarEntry['cellPhoneNumber'];
  email?: PatientCalendarEntry['email'];
}

export interface ImportResponse {
  value: string;
  error?: ImportError;
}

export interface ImportRowResponse {
  firstName: ImportResponse;
  lastName: ImportResponse;
  dateOfBirth: ImportResponse;
  patientEhrId: ImportResponse;
  cellPhoneNumber: ImportResponse;
  email: ImportResponse;
}

export const IMPORT_COLUMNS: (keyof ImportRow)[] = [
  'firstName',
  'lastName',
  'dateOfBirth',
  'patientEhrId',
  'cellPhoneNumber',
  'email',
];

interface BaseValues {
  userId: string;
  organizationId: string;
  name: string | null;
}

export interface Broadcast extends BaseItem, BaseValues {}

export interface BroadcastPopulated extends Broadcast {
  contents: Content.Content[];
  recipientCount: number;
}

export type FindAllFilter = {
  userId?: string[];
  organizationId?: string[];
  id?: string[];
};

export type FindAllOptions = FindAll<
  Pick<Broadcast, 'userId' | 'organizationId' | 'id'>,
  BaseItem & BaseValues
>;

export interface BroadcastDataArgs extends MessageLocalizationMap {
  contentIds?: string[];
  practiceId: string;
  importRows: Record<string, string>[];
}

export interface BroadcastBodyValues extends MessageLocalizationMap {
  name?: string;
  organizationId?: string | null;
}

export interface BroadcastTemplateContents {
  contents: Content.Content[];
}
